import { AutomationTabType } from "@/components/pages/automations/common/utils/types/types";

export const getScheduleNextRunDatesFixedCacheKey = (
  frequency?: AutomationTabType,
) => "postUsersMeSchedulesNextRunDate_fixedCacheKey" + frequency;
